module.exports = __webpack_public_path__ + "static/media/divider.93ecc53f.svg";